const AUDITS = [
  { id: 'AUDIT.01', title: 'GEMOLOGICAL LAB AUDIT', text: 'Every gemstone undergoes high-precision clinical testing in government-recognized laboratories to verify natural origin.' },
  { id: 'AUDIT.02', title: 'LINEAGE PURITY VERIFICATION', text: 'Raju Maharaj Ji conducts a spiritual audit of every item point to ensure correct vibrational frequency.' },
  { id: 'AUDIT.03', title: 'ENERGIZATION PROTOCOL', text: 'Verified items enter a 45-day ritual synchronization to activate latent energy points.' },
]
const CERT_BADGES = ['Lab Report Sync', 'Registered ID', 'Purity Sealed', 'Vedic Energized']

export default function CertificationSection() {
  return (
    <section className="relative overflow-hidden py-20 md:py-28 bg-background text-gray-800 font-normal select-none md:px-16">
      <div className="pointer-events-none absolute inset-0 opacity-[0.6] -z-10">
        <div className="absolute left-1/3 top-12 w-125 h-125 rounded-full bg-[radial-linear(circle,rgba(232,119,15,0.07)_0%,transparent_70%)] blur-3xl animate-[pulse_6s_ease-in-out_infinite]"></div>
        <div className="absolute right-10 bottom-4 w-112.5 h-112.5 rounded-full bg-[radial-linear(circle,rgba(123,13,30,0.05)_0%,transparent_70%)] blur-3xl animate-[pulse_8s_ease-in-out_infinite_reverse]"></div>
      </div>

      <div className="container relative z-10 mx-auto px-6 max-w-350">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left */}
          <div className="lg:col-span-7 space-y-10">
            <div className="max-w-2xl w-full text-left space-y-3">
              <span className="text-secondary text-[10px] tracking-[0.35em] uppercase font-bold block">QUALITY SYSTEM ASSURANCE</span>
              <h2 className="text-3xl md:text-5xl font-light text-primary leading-[1.1] uppercase font-heading">CERTIFIED <span className="font-bold text-secondary block sm:inline">STONE STANDARDS</span></h2>
              <div className="w-16 h-0.5 bg-secondary my-4"></div>
              <p className="text-gray-500 font-medium text-sm md:text-base tracking-wide uppercase leading-relaxed">Our clinical approach ensures every remedial entry you receive is 100% authentic and spiritually synchronized.</p>
            </div>

            <div className="grid grid-cols-1 gap-4">
              {AUDITS.map((a) => (
                <div key={a.id} className="flex gap-5 p-6 bg-white/60 hover:bg-white rounded-3xl border border-gray-200/50 hover:border-secondary/40 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group">
                  <div className="w-12 h-12 rounded-xl bg-primary/5 flex items-center justify-center text-secondary group-hover:bg-primary group-hover:text-white group-hover:rotate-12 transition-all duration-300 shrink-0 shadow-inner">
                    <i className="fa-solid fa-award w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div className="space-y-1">
                    <div className="flex items-center gap-3">
                      <span className="text-[9px] font-mono font-bold text-primary/30 uppercase tracking-widest">{a.id}</span>
                      <h4 className="text-base font-bold text-primary group-hover:text-secondary transition-colors uppercase">{a.title}</h4>
                    </div>
                    <p className="text-xs md:text-sm text-gray-500 font-normal leading-relaxed">{a.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Certificate */}
          <div className="lg:col-span-5 flex justify-center">
            <div className="relative w-full max-w-105 rounded-4xl bg-linear-to-b from-[#FFFDF6] via-[#FAF3DB] to-[#F1E4C3] p-4 shadow-[0_30px_70px_-20px_rgba(43,11,20,0.3)] ring-1 ring-amber-500/20 overflow-hidden group/cert">
              <div className="relative rounded-[1.6rem] border-2 border-double border-[#C99A2E]/50 px-6 py-8 md:px-8">
                <div className="pointer-events-none absolute inset-2 rounded-[1.2rem] border border-[#C99A2E]/20"></div>

                <div className="relative z-10 text-center space-y-4">
                  <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-linear-to-b from-[#F5DFA4] to-[#C99A2E] text-primary shadow-[0_8px_20px_-6px_rgba(201,154,46,0.6)] ring-4 ring-white/80">
                    <span className="text-2xl font-bold font-heading">ॐ</span>
                  </div>
                  <p className="text-[9px] font-bold tracking-[0.4em] text-[#9A7320] uppercase">ASTRO RAJU MAHARAJ</p>
                  <h3 className="text-xl md:text-2xl font-semibold tracking-tight text-primary uppercase font-heading">Certificate of Authenticity</h3>
                  <div className="flex items-center justify-center gap-3">
                    <span className="h-px w-10 bg-linear-to-r from-transparent to-[#C99A2E]"></span>
                    <span className="text-[#C99A2E] text-xs">✦</span>
                    <span className="h-px w-10 bg-linear-to-l from-transparent to-[#C99A2E]"></span>
                  </div>
                  <p className="mx-auto max-w-[18rem] text-[11px] md:text-xs text-primary/60 font-medium tracking-wide leading-relaxed normal-case">This certifies that the enclosed gemstone has been lab-verified for natural origin and energized as per authentic Vedic vidhi.</p>
                </div>

                <div className="relative z-10 mt-6 grid grid-cols-2 gap-2 text-left">
                  {CERT_BADGES.map((b) => (
                    <div key={b} className="flex items-center gap-2 rounded-xl bg-white/50 px-3 py-2 border border-amber-500/10 shadow-sm">
                      <i className="fa-solid fa-circle-check text-xs text-[#C99A2E]"></i>
                      <span className="text-[9px] font-bold tracking-wide text-primary/80 uppercase">{b}</span>
                    </div>
                  ))}
                </div>

                <div className="relative z-10 mt-6 pt-4 border-t border-[#C99A2E]/20 flex items-end justify-between">
                  <div className="text-left space-y-1">
                    <p className="text-xl text-primary font-medium" style={{ fontFamily: "'Brush Script MT', cursive, sans-serif" }}>Raju Maharaj</p>
                    <div className="h-px w-24 bg-[#C99A2E]/40"></div>
                    <p className="text-[8px] font-mono uppercase tracking-widest text-primary/40 font-bold">Authorized Signatory</p>
                  </div>
                  <div className="relative h-16 w-16 shrink-0 group-hover/cert:scale-105 transition-transform duration-500">
                    <div className="absolute inset-[15%] grid place-items-center rounded-full bg-linear-to-br from-[#E9C975] to-[#B98924] text-primary shadow-md shadow-amber-950/20 border border-white/40">
                      <div className="text-center leading-none"><i className="fa-solid fa-shield-halved text-xs text-primary"></i><span className="mt-0.5 block text-[6px] font-black uppercase tracking-widest">Verified</span></div>
                    </div>
                  </div>
                </div>
                <p className="relative z-10 mt-4 text-center text-[7px] font-mono uppercase tracking-[0.3em] text-primary/35 font-bold">Cert. No · ARM-GEM-2026-0098 · Protocol V4.2</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
